<template>
  <div class="flex flex-col items-center justify-center gap-4 text-gray-400 p-2.5">
    <div class="text-md text-text-explanatory-default flex gap-[.56rem] items-center">
      <Icon icon="APP-Fill-Wechat" class="size-[1.4rem]" />
      {{ $t('home.user.loginForm.scanText') }}
    </div>
    <WxQrcode
      :redirect-url="WEB_SCAN_LOGIN_REDIRECT_URL"
      size="13.1875rem"
      :handle-iframe-message="handleMessage"
      @scan-login-success="handleMessage"
    />
  </div>
</template>

<script setup lang="ts">
  import { Icon } from '@rapoo/element'
  import { toast } from 'vue-sonner'
  import { useRouter } from 'vue-router'
  import { useLocaleStore, useUserStore } from '@/stores'
  import WxQrcode from '@/components/WxQrCode.vue'

  const { scanLogin } = useUserStore()
  const { t } = useLocaleStore()
  const router = useRouter()

  const WEB_SCAN_LOGIN_REDIRECT_URL = 'https://auth.rapoo.cn/ahubWx/loginRedirect.html'

  const handleMessage = (event: MessageEvent) => {
    if (!event.data) return

    const res = JSON.parse(event.data)
    const { data, errorMes } = res || {}

    if (errorMes) {
      toast.error(errorMes)
    }

    if (data) {
      scanLogin(data)
      toast.success(t('home.user.loginForm.loginSuccessful'))
      router.push('/')
    }
  }
</script>

<style lang="scss" scoped>
  #wechat-login-container {
    :deep(iframe) {
      width: 100% !important;
      height: 100% !important;
    }
  }

  :deep(.icon) {
    transform: translateX(2px);
  }
</style>
